































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";

import { mapGetters } from "vuex";
// 13 07准则 引入ts 的表格数据
import balanceSheetData, { BalanceSheetData } from "../data/balanceSheetData";
import version from "@/version";
import AccountingSystem from "@/data/AccountingSystem";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue
    }
})
export default class BalanceSheet extends Vue {
    // 07 13 准则表格数据
    dataList: BalanceSheetData[] = [];
    // 是否不平衡
    isBalance: boolean = false;
    //改变时间
    period: string[] = []; // 日期

    isOrigin = true;

    originTypeList = [
        {
            key: "全部重分类",
            value: 0
        },
        {
            key: "一级科目重分类",
            value: 1
        }
    ];
    originType = 0;

    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        let data = [];
        Vue.axios
            .post(`balancesheet/find`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period,
                orign: 1
            })
            .then(res => {
                if (res.data.isRight === 0) this.isBalance = true;
                else this.isBalance = false;
                data = balanceSheetData.getData(this.$store.state.accountBook);
                for (let i = 0; i < data.length; i++) {
                    //循环获取资产期末余额
                    data[i].assetEndBalance = res.data.assetEndBalances[i];
                    //循环获取资产期初余额
                    data[i].assetInitBalance = res.data.assetInitBalances[i];
                    //循环获取负债期末余额
                    data[i].equityEndBalance = res.data.equityEndBalances[i];
                    //循环获取负债期初余额
                    data[i].equityInitBalance = res.data.equityInitBalances[i];
                }
                this.dataList = data;
                this.isOrigin = res.data.isOrigin === 0;
                this.originType = res.data.originType;
            });
    }
    // 不平衡
    showMes() {
        Vue.axios
            .post(`balancesheet/getMessage`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period
            })
            .then(res => { this.$alert(res.data.PromptMessage, "温馨提示") });
    }

    changeOrigin(val: boolean) {
        Vue.axios
            .post(`systemsettings/save`, {
                accountBookId: this.$store.state.accountBook.id,
                keyword: "BALANCE_SHEET_ORIGIN",
                value: this.isOrigin ? 0 : 1
            })
            .then(res => {
                this.fetchData();
            });
    }

    async changeOriginType() {
        await Vue.axios.post(`systemsettings/save`, {
            accountBookId: this.$store.state.accountBook.id,
            keyword: "BALANCE_SHEET_ORIGIN_TYPE",
            value: this.originType
        });
        this.fetchData();
    }

    // 是否已结账，大于已结帐日期 显示 充分累，否则隐藏
    // get originVisible(): boolean {
    //     return (+this.period > +this.$store.state.accountBook.closePeriod || this.$store.state.accountBook.closePeriod === null) && this.$store.state.accountBook.accountingSystem !== AccountingSystem.rural;
    // }

    downLoad() {
        this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/balancesheet?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&endPeriod=${this.period}&version=${version}&token=${this.$store.state.account.token}`)
    }
}
